module.exports = __webpack_public_path__ + "static/img/齿轮式圆形开合机构模型.43045df0.jpg";